<div class="p-2">
    <h1 mat-dialog-title>Update Member</h1>
    <div mat-dialog-content>
        <div [formGroup]="formControl">
            <div class="row justify-content-between mt-4">
                <div class="col-lg-6 col-12 d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>First Name <span class="required-input">*</span></mat-label>
                        <input matInput placeholder="Enter first name"
                            formControlName="firstName" [errorStateMatcher]="matcher" required>
                    </mat-form-field>
                    <mat-error *ngIf="!formControl.controls['firstName'].value"></mat-error>
                </div>
                <div class="col-lg-6 col-12 d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Last Name <span class="required-input">*</span></mat-label>
                        <input matInput placeholder="Enter last name" formControlName="lastName"
                            [errorStateMatcher]="matcher" required>
                    </mat-form-field>
                    <mat-error *ngIf="!formControl.controls['lastName'].value"></mat-error>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-lg-6 col-12 d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Email <span class="required-input">*</span></mat-label>
                        <input matInput placeholder="Enter email"
                            formControlName="emailAddress" [errorStateMatcher]="matcher" required>
                    </mat-form-field>
                    <mat-error *ngIf="!formControl.controls['emailAddress'].value"></mat-error>
                </div>
                <div class="col-lg-6 col-12 d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Phone Number</mat-label>
                        <input matInput placeholder="Enter phone number" formControlName="phone" (input)="onPhoneNumberChanged($event)">
                        <mat-hint>Ex: (XXX) XXX-XXXX</mat-hint>
                        <mat-error *ngIf="formControl.controls['phone'].invalid">
                            Required format | (XXX) XXX-XXXX
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    <div class="mx-4 mb-2 d-flex align-items-center justify-content-end text-muted">
        <span class="required-input">*</span>&nbsp;- Required fields
    </div>
    <div class="mt-4 mb-2 d-flex justify-content-end">
        <button mat-raised-button class="cancel-button" (click)="onCloseClick()">Cancel</button>
        <button mat-raised-button class="action-button" (click)="onSaveClick()" [disabled]="!formControl.valid">Submit</button>
    </div>
</div>